export const fixImageUrl = (url) => {
    if (!url) return '';
    // If the URL is absolute and points to localhost, make it relative
    // If the URL is absolute and points to the API server (in dev), make it relative if needed
    // But since we use proxy, we can often just leave valid URLs alone or strip the domain if it matches current origin.
    // For now, let's just ensure we don't hardcode localhost:5000
    // If it starts with http/s, checking if it matches our backend is complex without env vars.
    // However, the original code wanted to strip localhost:5000. 
    // We will strip the origin if it matches the window location or common dev ports to be safe, but primarily we rely on relative paths.
    if (url.startsWith('http://localhost:5000')) {
        url = url.replace('http://localhost:5000', '');
    } else if (url.startsWith(window.location.origin)) {
        url = url.replace(window.location.origin, '');
    }

    // Replace backslashes with forward slashes
    let fixedUrl = url.replace(/\\/g, '/');

    // If it's not absolute (http/https) and doesn't start with /, add /
    if (!fixedUrl.match(/^https?:\/\//) && !fixedUrl.startsWith('/')) {
        fixedUrl = '/' + fixedUrl;
    }

    return fixedUrl;
};
